<template>
  <div id="footer">
    <div class="top-line">
      <!-- <a
        class="policylink"
        href="https://www.cosmo-japan.net/okazukan_official/"
        >プライバシーポリシー</a
      >
      <a
        class="policylink"
        href="https://www.cosmo-japan.net/nonoshiri_official/"
        >サイトポリシー</a
      > -->
      <div class="top-line">
          ※端末の性能や仕様、端末固有のアプリ使用状況などにより、正常に動作しない場合があります。
      </div>
      <a class="policylink" href="./privacy-policy/index.html">プライバシーポリシー</a>
      <a class="policylink" href="./site-policy/index.html">サイトポリシー</a>
    </div>
    <div class="bottom-line">
      <a class="policylink" href="https://www.cosmo-japan.net/"
        >© 2021 Cosmo Japan Co., Ltd. All Rights Reserved.</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterItem",
  methods: {
    clickPrivacyPolicy() {
      //this.$emit('hideHeader');
      //this.$router.push('privacy-policy');
      let routeData = this.$router.resolve("privacy-policy");
      window.open(routeData.href, "_blank");
    },
    clickSitePolicy() {
      // this.$emit('hideHeader');
      // this.$router.push('site-policy');
      let routeData = this.$router.resolve("site-policy");
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
#footer {
margin: 0;
  color: black;
  background-color: #DB6451;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
  text-align: center
}

.top-line {
  padding-top: 10px;
  padding-bottom: 10px;
}
.center-line,

 .bottom-line {
  padding: 15px;
}

.const {
  display: inline-block;
  margin: 0 10px;
}

.policylink {
  color: black;
  text-decoration: none;
  padding: 10px;
}

a {
  text-decoration: none;
}
  /* text-align: center;
  margin: 0;
  color: black;
  background-color: #db6451;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.top-line {
  padding-top: 15px;
} */
/* .center-line,
.bottom-line {
  padding: 15px;
}

.const {
  display: inline-block;
  margin: 0 10px;
}

.policylink {
  color: black;
  text-decoration: none;
  padding: 10px;
}

a {
  text-decoration: none;
} */



</style>
